module.exports = __webpack_public_path__ + "75853b15efc3b72984ac359f5c23526b.jpg";


//////////////////
// WEBPACK FOOTER
// ../images/speakers/arun-michael-dsouza.jpg
// module id = 433
// module chunks = 0